const CACHE_KEY = "psarah_trans_cache_v2";
const cache: Record<string, string> = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");

function saveCache() {
  localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
}

// Limpia tildes para que Google no devuelva caracteres raros
function cleanForTranslate(text: string) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

async function translateSingle(text: string, targetLang: string): Promise<string> {
  // No traducir si es dato: fecha, dinero, numero, email
  if (/^\$|^\d{4}-\d{2}-\d{2}|^[\d.,\s$]+$|@/.test(text.trim())) return text;
  if (text.length < 2 || /^[0-9\W]+$/.test(text)) return text;
  if (text.includes("MYMEMORY")) return text;

  const clean = cleanForTranslate(text);
  if (cache[clean]) return cache[clean];

  try {
    // Endpoint gratis de Google - el mismo que usa translate.google.com
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=es&tl=${targetLang}&dt=t&q=${encodeURIComponent(clean)}`;
    const res = await fetch(url);
    const data = await res.json();
    const translated = data[0]?.map((item: any) => item[0]).join("") || text;

    cache[clean] = translated;
    cache[text.trim()] = translated; // guarda ambas versiones
    saveCache();
    return translated;
  } catch {
    return text;
  }
}

export async function translateBatch(texts: string[], targetLang: string): Promise<Record<string, string>> {
  if (targetLang === 'es') {
    const r: Record<string, string> = {};
    texts.forEach(t => r[t] = t);
    return r;
  }

  const unique = [...new Set(texts.map(t => t.trim()).filter(t => t.length > 1))];
  const toTranslate = unique.filter(t =>!cache[t] &&!cache[cleanForTranslate(t)]);

  // Traduce de 5 en 5 para no saturar
  for (let i = 0; i < toTranslate.length; i += 5) {
    const chunk = toTranslate.slice(i, i+5);
    await Promise.all(chunk.map(t => translateSingle(t, targetLang)));
    await new Promise(r => setTimeout(r, 100));
  }

  const result: Record<string, string> = {};
  texts.forEach(t => {
    const key = t.trim();
    result[t] = cache[key] || cache[cleanForTranslate(key)] || t;
  });
  return result;
}

export function getCached(text: string) {
  return cache[text.trim()] || cache[cleanForTranslate(text.trim())] || null;
}